<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template
      v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs">
        <!-- Team View/Edit form -->
        <md-tab id="tab-account" md-label="Team" :to="recordPath" exact>
          <CustomTeamForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :headerColor="headerColor"></CustomTeamForm>
        </md-tab>
        <!-- Users tab -->
        <md-tab id="tab-users" md-label="Users" :to="recordPath + '/users'">
          <ElasticList 
            ref="usersListRef"
            v-if="$route && $route.meta.tab === 'users'" 
            :list.sync="usersList" 
            :filter="teamUserTeamId">
          </ElasticList>

          <md-dialog :md-active.sync="usersList.showRelatedDialog">
            <md-dialog-title>{{relateUsersList.pageTitle}}</md-dialog-title>
            <md-dialog-content>

              <ElasticList
                v-if="recordData"

                :list.sync="relateUsersList"
                :exclude="relateTeamUserFilter"
                :relateRecordInput="{teamUserUserId: null, teamUserTeamId: $route.params.id}"
                relateRecordInputField="teamUserUserId"
              ></ElasticList>

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="usersList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>
        
      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <CustomTeamForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :headerColor="headerColor"></CustomTeamForm>
    </div>


  </div>
</template>

<script>
  import Record from '@/mixins/Record';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import { helpers } from 'vuelidate/lib/validators';
  const alpha = helpers.regex('alpha', /^[a-zA-Z0-9\s\-]+$/);

  export default {
    name: "team",
    mixins: [Record],
    computed: { 
      teamUserTeamId: function() {
        return {
          match_phrase: {
            teamUserTeamId: this.$route.params.id,
          },
        };
      },
      relateTeamUserFilter: function() {
        let result1 = null;
        if (this.recordData && this.recordData.users && this.recordData.users.items) {
          let items = this.recordData.users.items;
          let filters = [];
          items.forEach(item => {
            filters.push({"match": {"id": item.user.id}});
          });
          if (filters.length) {
            result1 = {"must_not": filters};
          }
        } 
        return result1;
      },
    },
    data() {
      return {
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'teamUpdatedById',
          responseFieldName: 'getTeam',
          actions: {
            save: 'createTeam',
            view: 'editTeam',
            edit: 'editTeam',
            new: 'getTeam',
            update: 'updateTeam',
            delete: 'deleteTeam',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":12,"i":"0"}},
          },
          listPath: "/teams",
          headerIcon: 'group',
          objectName: 'Team',
          objectNamePlural: 'Teams',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            name: { label: "Name", type: "text", slot: 'basic', preventEdit: true},
            // cognito_groupid: { label: "Group Name", type: "id", slot: 'basic', preventEdit: true},
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          name: "",
          // cognito_groupid: ""
        },
        usersList: {
          refreshData: false,
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "users",
          pageTitle: "Users",
          pageIcon: "style",
          listQueryId: "searchTeamUsers",
          deleteQueryId: "deleteTeamUser",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Team?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          userGroupId: "cognito_groupid",
          columns: {
            'esData.user.given_name': { label: "First Name", sortable: false, esNested: true},
            'esData.user.family_name': { label: "Last Name", sortable: false, esNested: true},
            role: { label: "Role", sortable: false },
            cognito_groupid: { label: "Cognito Group", sortable: false },
            createdAt: { label: "Created", sortable: false },
          },
          currentSort: "createdAt",
          currentSortOrder: "asc",
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchTeamUsers && data.searchTeamUsers.items.length) {
              data.searchTeamUsers.items.forEach((item) => {
                item.relateRecordId = item.id;
                item.role = 'Team ' + item.role;
                item.cognito_groupid = item.cognito_groupid.replace(/_/g, " ");
                //set name for message on delete user action
                item.name = item.user.given_name + ' ' + item.user.family_name;

                result.push(item);
              })
            }
            return result;
          },
        },
        relateUsersList: {
          hideListHeader: true,
          skipCardLayout: true,
          teamFroup:'',
          editPath: "user",
          pageTitle: "Search for User",
          pageIcon: "style",
          listQueryId: "searchUsers",
          createMutationId: "createTeamUser",
          deleteQueryId: "deleteTeamUser",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAddRole"
            }
          ],
          columns: {
            given_name: { label: "First Name", sortable: true },
            family_name: { label: "Last Name", sortable: true },
            email: { label: "Email", sortable: true },
          },
          roleRecord: {
            Lead: "Team Lead", 
            Member: "Team Member",
            Watcher: "Team Watcher"
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'asc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchUsers';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                result.push(item);
              })
            }
            return result;
          },
        },
        subscriptions: {
          'onCreateTeamUser': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateTeamUser');
              let eventRecord = eventData.value.data.onCreateTeamUser;
              /** Filter out records that do not apply to the team we are looking at */
              if (this.recordData.id === eventRecord.team.id) {
                // refresh users list after 1 sec
                setTimeout(() => {
                  this.$refs.usersListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);
              }
            }
          },
          'onDeleteTeamUser': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteTeamUser');
              let eventRecord = eventData.value.data.onDeleteTeamUser;
              if (this.recordData.id === eventRecord.team.id) {
                // refresh users list after 1 sec
                setTimeout(() => {
                  this.$refs.usersListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 1000);
              }
            }
          },
        },
      }
    },
    validations() {
      return {
        form: {
          id: {},
          name: {required, alpha},
          // cognito_groupid: {}
        }
      }
    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;
    .md-tab-nav-button.md-button {
        color: black !important;

        &.active {
          color: black !important;
          border-bottom: 2px solid black;
        }
      }
    }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

</style>
